import { WidgetProps } from '@highimpact-front/remote-widget-core';
import { GenericErrorBoundary } from '@highimpact/dashboard-ui';
import { PermissionDecorator } from '@highimpact/react-decorators';
import { forwardRef, type LegacyRef } from 'react';
import { useDashboardPermissionScope } from '../../../../hooks/useDashboardPermissionScope';
import { setDeleteWidgetConfirmation } from '../../../../state/dashboard/slice';
import NameHandlerComponent from '../../../NameHandlerComponent';
import Widget from '../../commons/Widget';
import { WidgetToolbar } from '../../commons/WidgetToolbar';

import { useDashboardLibraryDispatch } from '../../../../runtime/DashboardLibraryProvider';
import { useTextInstanceRegistration } from '../text/useTextInstanceRegistration';
import { WidgetDragHandle } from '../../commons/WidgetDragHandle';
interface TextProps extends WidgetProps {
  name: string;
  text: string;
  gridId: number;
  gridType: 'reports' | 'grids';
}

function TextFromEntityDisplayer(
  {
    dashboardElementId,
    name,
    text,
    className,
    non_removable,
    gridType,
    gridId,
    ...props
  }: TextProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const dispatch = useDashboardLibraryDispatch();
  const { site_id, project_id } = useDashboardPermissionScope();

  useTextInstanceRegistration({
    dashboardElementId,
    widgetId: props.widget_id,
    textValue: text,
    enabled: true,
  });

  return (
    <Widget
      dashboardElementId={dashboardElementId}
      ref={ref}
      {...props}
      className={`text ${className || ''}`}
    >
      <GenericErrorBoundary>
        <PermissionDecorator
          item="dashboard_nav_bar_widget"
          project_id={project_id}
          site_id={site_id}
          extra={{ dashboard_id: gridId }}
        >
          <div className="widget-nav">
            <p style={{ display: 'flex' }}>
              {!props.dashboardOnlyMode && (
                <PermissionDecorator item="dashboard_move_widget">
                  <WidgetDragHandle />
                </PermissionDecorator>
              )}
              <PermissionDecorator item="dashboard_rename_widget">
                <NameHandlerComponent
                  widgetId={dashboardElementId}
                  dashboardElementId={props.widget_id}
                  dashboardId={gridId}
                  dashboardType={gridType}
                />
              </PermissionDecorator>
            </p>
            {!props.dashboardOnlyMode && !non_removable && (
              <div className="nav-icon">
                <WidgetToolbar
                  dashboardElementId={dashboardElementId}
                  dashboardId={gridId}
                  // TODO: replace
                  platformActions={{
                    delete: {
                      visible: true,
                      tooltipText: "Supprimer l'élément",
                      permissionItem: 'dashboard_delete_widget',
                      onClick: () =>
                        dispatch(
                          setDeleteWidgetConfirmation({
                            state: 'open',
                            dashboardElementId: dashboardElementId,
                            widgetName: name,
                          })
                        ),
                    },
                  }}
                />
              </div>
            )}
          </div>
        </PermissionDecorator>
        <div className="widget-content">
          <h4 className="value" style={{ margin: 0 }}>{text}</h4>
        </div>
      </GenericErrorBoundary>
    </Widget>
  );
}

export default forwardRef(TextFromEntityDisplayer);
